// src/components/Arranger.js
import React from 'react';

import DrumPlayer from './DrumPlayer';
import ChordButtons from './ChordButtons';
import RealPiano from './Realpiano';

const Arranger = () => {
  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h2>🎶 Web Arranger</h2>
      <DrumPlayer />
      <ChordButtons />
      <RealPiano />
    </div>
  );
};

export default Arranger;
